import { Assert } from "../../Assert";
import { Constructor } from "../../Extensions";
import { Attribute, AttributePropertyValues, IAttribute } from "../../Server/DotNet/System.Runtime/Attribute";
import { IInputControl, InputControlPropertyValues } from "./InputControl";

export type PropertyEditorAttributePropertyValues<TInputControl extends IInputControl<TInputControlPropertyValues>, TInputControlPropertyValues extends InputControlPropertyValues> =
    AttributePropertyValues
    & {
        inputControl: Constructor<TInputControl>;
        inputControlPropertyValues: Partial<TInputControlPropertyValues>;
    };

export type PropertyEditorAttributeProperties<TInputControl extends IInputControl<TInputControlPropertyValues>, TInputControlPropertyValues extends InputControlPropertyValues> = {
    [name in keyof PropertyEditorAttributePropertyValues<TInputControl, TInputControlPropertyValues>]?: PropertyEditorAttributePropertyValues<TInputControl, TInputControlPropertyValues>[name];
};

export interface IPropertyEditorAttribute<TInputControl extends IInputControl<TInputControlPropertyValues>, TInputControlPropertyValues extends InputControlPropertyValues> extends IAttribute, PropertyEditorAttributeProperties<TInputControl, TInputControlPropertyValues>
{
}

export class PropertyEditorAttribute<TInputControl extends IInputControl<TInputControlPropertyValues>, TInputControlPropertyValues extends InputControlPropertyValues> extends Attribute implements IPropertyEditorAttribute<TInputControl, TInputControlPropertyValues>
{
    public inputControl: Constructor<TInputControl>;
    public inputControlPropertyValues: Partial<TInputControlPropertyValues>;

    constructor(propertyValues?: Partial<PropertyEditorAttribute<TInputControl, TInputControlPropertyValues>>)
    {
        super(propertyValues);

        Assert.isNotNullOrUndefined(propertyValues?.inputControl, "propertyValues?.inputControl");

        this.inputControl = propertyValues.inputControl;
        this.inputControlPropertyValues = propertyValues?.inputControlPropertyValues ?? {}
    }

    public createInputControl()
    {
        return new this.inputControl(this.inputControlPropertyValues);
    }
}